import { useMutation, UseMutationResult, useQuery, UseQueryResult } from '@tanstack/react-query'

import { ObstructionType } from 'models'

import { ObstructionReportPayload, ObstructionReportResponse } from '../../models/ObstructionReport.model'
import { ApiQueryService } from '../../services'

export function useObstructionReportForm(): UseMutationResult<
  ObstructionReportResponse,
  Error,
  ObstructionReportPayload
> {
  const postObstructionReportForm = async (payload: ObstructionReportPayload): Promise<ObstructionReportResponse> => {
    try {
      const response = await new ApiQueryService().post<ObstructionReportResponse>({
        data: payload,
        endpoint: 'obstruction-report',
      })

      if (response) {
        return response
      } else {
        throw new Error('Api Error')
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      let errText = 'API Failed'
      if (error?.response?.data?.error !== undefined) {
        errText = error.response.data.error
      } else if (error.message !== undefined) {
        if (error.message === '[object Object]') {
          errText = 'Something went wrong. Please try again.'
        } else {
          errText = error.message
        }
      }
      if (errText === 'Network Error' || errText === 'timeout exceeded') {
        throw new Error('please_check_your_internet_connection')
      } else {
        throw new Error(errText)
      }
    }
  }
  return useMutation<ObstructionReportResponse, Error, ObstructionReportPayload>({
    mutationFn: postObstructionReportForm,
  })
}

export function useGetObstructionType(): UseQueryResult<ObstructionType[], Error> {
  const getObstructionReportForm = async (): Promise<ObstructionType[]> => {
    try {
      const response = await new ApiQueryService().get<ObstructionType[]>({
        endpoint: 'obstruction-type/list',
      })

      if (response) {
        return response
      } else {
        throw new Error('Api Error')
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      let errText = 'API Failed'
      if (error?.response?.data?.error !== undefined) {
        errText = error.response.data.error
      } else if (error.message !== undefined) {
        errText = error.message
      }
      if (errText === 'Network Error' || errText === 'timeout exceeded') {
        throw new Error('please_check_your_internet_connection')
      } else {
        throw new Error(errText)
      }
    }
  }
  return useQuery<ObstructionType[], Error>({
    queryFn: getObstructionReportForm,
    queryKey: ['obstruction-report'],
  })
}
